import React from 'react';
import _ from 'lodash'
import {IDefaultUiName, IUiContent} from '../types/IUiContent';

export const getTranslate = (content: IUiContent[], lang: string) => (id: number): string => {
    const foundContent: IUiContent | undefined = content.find((item: IUiContent) => item.id === id);
    const translate: IDefaultUiName | undefined | null  = foundContent
        ? foundContent.defaultUiNames.find((name: IDefaultUiName) => name.lang === lang)
        : null;

    const missing = `missing translation ${id}`;

    return translate ? translate.name : missing;

}

// Fills `<%= name %>` the way lodash `_.template` did, without compiling the
// string (which a CSP without 'unsafe-eval' blocks). Unknown or nullish values
// become ''; anything that is not a plain name is left as is.
const placeholder = /<%=\s*([A-Za-z_$][\w$]*)\s*%>/g

export const translateTemplate = (translate: string, replace: {}) => isTemplate(translate) ?
    translate.replace(placeholder, (match: string, name: string) => {
        const value = _.has(replace, name) ? replace[name] : undefined
        return value == null ? '' : String(value)
    }) :
    translate

const isTemplate = template => _.isEqual(typeof template, 'string')
